// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__2VP8V","Label":"Checkbox_Label__30ExJ","InputElement":"Checkbox_InputElement__2XV07","Invalid":"Checkbox_Invalid__2EBUs"};